import { render, staticRenderFns } from "./isRuledButNotRestructuring.vue?vue&type=template&id=3a7ac4c4&"
import script from "./isRuledButNotRestructuring.vue?vue&type=script&lang=js&"
export * from "./isRuledButNotRestructuring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports